import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { loadArchiveSettingsFailed, loadArchiveSettingsSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* loadArchiveSettings(action) {
  try {
    const url = `${BACKEND_URL}/api/v1/archive-settings`;
    const dataResponse = yield makeRequest(url, {}, action, 'GET', true);
    const data = yield dataResponse.json();
    if (dataResponse.status === OK) {
      yield put(loadArchiveSettingsSuccessful(data.data));
      yield call(resolveActionPromise(action, data.data));
    } else {
      yield put(loadArchiveSettingsFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(loadArchiveSettingsFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
